import type { Priorite } from '../partage/api/types';
import { filtreEnvoye } from './filtreDeLaCarte';

/** Ce que la carte demande à `GET /api/feuille/:id/carte`. */
export interface DemandeDeLaCarte {
  ouvertes: readonly string[];
  /** La profondeur affichée : le serveur y lit les places gardées (chantier deplacer-les-bulles). */
  profondeur: number;
  /** L'importance du filtre, à partir de la profondeur 2 (`filtreEnvoye`) ; `null` sinon. */
  importance: Priorite | null;
}

/**
 * Faut-il demander les places au serveur, et avec quoi (chantier deplacer-les-bulles, ticket 03) ?
 * À la profondeur 1, rien d'ouvert sur place et sans filtre, la feuille porte déjà sa carte (lue à
 * la profondeur 1) : `null`. Sinon on demande, et **la profondeur affichée part toujours** : une
 * bulle déplacée garde une place par profondeur, et une profondeur 2 sans elle se rangerait comme
 * la 1. Règle pure, sans réseau.
 */
export function demandeDeLaCarte(
  ouvertes: readonly string[],
  profondeur: number,
  enAvant: Priorite | null
): DemandeDeLaCarte | null {
  const filtre = filtreEnvoye(enAvant, profondeur);
  if (ouvertes.length === 0 && profondeur <= 1 && filtre === null) return null;
  return { ouvertes, profondeur, importance: filtre?.importance ?? null };
}
